import React from 'react';

import {Menu} from '@albert-io/atomic';
import {useGoogleClassroomSync} from 'client/components/ContentDiscovery/Document/AssignmentSharing/useGoogleClassroomSync';

import {invalidateClassGoogleClassroomSync} from './invalidateClassGoogleClassroomSync';

interface Props {
  assignmentId: string;
  classroomId: string;
}

/**
 * "More options" item that removes a synced assignment from its Google Classroom course. The row's
 * sync icon only syncs and resyncs, so this is where a teacher unsyncs from the assignment list.
 * Render it only for synced assignments.
 */
export const GoogleClassroomUnsyncMenuItem = ({assignmentId, classroomId}: Props) => {
  const {isRequestPending, unsync} = useGoogleClassroomSync(assignmentId, classroomId, true);

  return (
    <Menu.Item
      leftIconProps={{icon: 'link-slash'}}
      disabled={isRequestPending}
      onClick={(e) => {
        e.stopPropagation();
        unsync().then(() => invalidateClassGoogleClassroomSync(classroomId));
      }}
    >
      Unsync from Google Classroom
    </Menu.Item>
  );
};
